export const basicAdvancedSearch = [
  {
    label: "Available Quantity",
    value: "available_quantity"
  },
  {
    label: "Barcode Number",
    value: "barcode"
  },
  {
    label: "Category",
    value: "category"
  },
  {
    label: "Color",
    value: "color"
  },
  {
    label: "Condition",
    value: "condition"
  },
  {
    label: "Created On",
    value: "created_at"
  },
  {
    label: "Description",
    value: "description"
  },
  {
    label: "Description Comments",
    value: "description_comments"
  },
  {
    label: "Dimensions",
    value: "dimensions"
  },
  {
    label: "Disposition",
    value: "disposition"
  },
  {
    label: "Finish",
    value: "finish"
  },
  {
    label: "Manufacturer",
    value: "manufacturer"
  },
  {
    label: "Minimum Quantity",
    value: "minimum_quantity"
  },
  {
    label: "Model",
    value: "model"
  },
  {
    label: "Origin Building",
    value: "existing_building"
  },
  {
    label: "Origin Comments",
    value: "origin_comments"
  },
  {
    label: "Origin Cubby Number",
    value: "origin_cubby_number"
  },
  {
    label: "Origin Employee Name",
    value: "origin_employee_name"
  },
  {
    label: "Origin Floor",
    value: "existing_floor"
  },
  {
    label: "Origin Quantity",
    value: "quantity"
  },
  {
    label: "Origin Room Name",
    value: "existing_room"
  },
  {
    label: "Origin Room Number",
    value: "origin_room_number"
  },
  {
    label: "OS&D",
    value: "has_osd"
  },
  {
    label: "Subcategory",
    value: "subcategory"
  },
  {
    label: "Unit Cost",
    value: "unit_cost"
  },
  {
    label: "Weight",
    value: "weight"
  }
];

export const medicalAdvancedSearch = [
  {
    label: "Department Name",
    value: "department_name"
  },
  {
    label: "Destination Building",
    value: "new_building"
  },
  {
    label: "Destination Comments",
    value: "destination_comments"
  },
  {
    label: "Destination Employee Name",
    value: "destination_employee_name"
  },
  {
    label: "Destination Floor",
    value: "new_floor"
  },
  {
    label: "Destination Quantity",
    value: "destination_quantity"
  },
  {
    label: "Destination Room Name",
    value: "new_room"
  },
  {
    label: "Destination Room Number",
    value: "destination_room_number"
  },
  {
    label: "Install responsibility",
    value: "install_responsibility"
  },
  {
    label: "PO Number",
    value: "po_number"
  },
  {
    label: "Quantity Ordered",
    value: "quantity_ordered"
  },
  {
    label: "Storage Location(s)",
    value: "rack_locations"
  }
];
